module.exports = __webpack_public_path__ + "img/0cd7b55.png";